import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const HelpCenter: RouteConfig = {
  path: '/help',
  component: Layout,
  redirect: 'noredirect',
  name: 'helpMenu',
  meta: {
    title: 'help',
    permission: 'helpMenu',
    icon: 'guide'
  },
  children: [{
    path: 'order-manage/index',
    component: () => import(/* webpackChunkName: "HelpCenter" */ '@/views/help/helpcenter/index.vue'),
    name: 'helpMenu',
    meta: {
      title: 'helpcenter',
      permission: 'HelpCenter',
      noCache: true,
      icon: 'help-manage'
    }
  },
  {
    path: 'helplist/index',
    component: () => import(/* webpackChunkName: "helplist" */ '@/views/help/helplist/index.vue'),
    name: 'helplist',
    meta: {
      title: 'helplist',
      permission: 'helplist',
      noCache: true,
      icon: 'help-center'
    }
  },
  {
    path: 'createdocuments/index',
    component: () => import(/* webpackChunkName: "createDocuments" */ '@/views/help/createdocuments/index.vue'),
    name: 'createDocuments',
    meta: {
      title: 'createdocuments',
      permission: 'createDocuments',
      noCache: true,
      icon: 'help-word'
    }
  }]
}

export default HelpCenter
